<div class="p-6 max-w-5xl mx-auto">
  <div class="flex flex-row justify-between items-center mb-5">
    <div>
      <h1 class="text-2xl font-semibold mb-1">Send text message</h1>
      <p class="text-sm text-muted-color">User ID: {{ userId() }}</p>
    </div>
    <p-button icon="pi pi-arrow-left" label="Back" (onClick)="goBack()"></p-button>
  </div>

  <textarea
    pTextarea
    [value]="jsonInput()"
    (input)="onJsonInput($event)"
    class="w-full rounded border border-300 bg-white p-3 text-sm font-mono min-h-[220px]"
    rows="12"
  ></textarea>

  @if (validationError(); as error) {
    <p class="text-sm text-red-600 mt-2">{{ error }}</p>
  }

  <div class="flex flex-row gap-2 mt-4">
    <homey-submit-button label="Send text message" [submitFunction]="sendTextMessage"></homey-submit-button>
    <p-button label="Reset JSON" icon="pi pi-undo" severity="secondary" (onClick)="resetJson()"></p-button>
  </div>
</div>
